import { AnyAction } from 'redux';

import { StateType } from '../../../../../states';
import { type BasketState } from '../../../../../states/basket';
import recomputeNextMissionBasketState from '../../../../missions/utils/recomputeNextMissionBasketState';

import basketResetBoomActives from './basketResetBoomActives';

const basketItemSetBoomActive = (state: BasketState, action: AnyAction, globalState: StateType): BasketState => {
  const { oddsId, isActive, skinId, stepId } = action.payload;

  const resetedState = basketResetBoomActives(state);
  const { items } = resetedState;

  const item = items[oddsId];

  if (item) {
    const nextState = {
      ...resetedState,
      items: {
        ...items,
        [oddsId]: {
          ...item,
          isBoomActive: isActive,
          selectedFreebetId: isActive ? undefined : item.selectedFreebetId,
          boom: {
            skinId,
            stepId,
          },
        },
      },
    };

    return recomputeNextMissionBasketState(nextState, globalState);
  }

  return state;
};

export default basketItemSetBoomActive;
